var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container mt-2 text-center" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12 h1" }, [
        _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-12 h4" }, [
        _vm._v(
          "\n      Enter your email address, click the Recover Password button, then check your email for a confirmation code.\n    "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row m-4 justify-content-md-center" }, [
      _c("div", { staticClass: "col-sm-12 col-md-4" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-primary col-sm-12 mt-1 mb-1",
            attrs: { type: "button" },
            on: { click: _vm.recover },
          },
          [
            _vm._v("\n          Recover Password "),
            _c("i", { staticClass: "fas fa-sign-in-alt" }),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group" }, [
      _c("label", { attrs: { for: "email" } }, [_vm._v("Email address")]),
      _vm._v(" "),
      _c("input", {
        staticClass: "form-control",
        attrs: {
          type: "email",
          id: "email",
          "aria-describedby": "emailHelp",
          placeholder: "Enter email",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }